import { isEmpty } from 'lodash';
import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const getAllNewsFeed = async ({ account_id, filter, offset, limit, search }) => {
    const queryParams = {
        account_id: account_id ? account_id : '',
        filter: !isEmpty(filter) ? encodeURIComponent(JSON.stringify(filter)) : '',
        offset: offset ? offset : '',
        limit: limit ? limit : '',
        search: search ? search : '',
    };
    const url = constructURL(API.NEWS_FEED, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

// to get specific news feed
export const getSpecificNewsFeed = ({ id }) => {
    let url = `${API.NEWS_FEED}/${id}`;
    return fetchData({ method: METHODS.GET, url });
};

// to create news feed
export const createNewsFeed = async ({ data }) => {
    let url = `${API.NEWS_FEED}`;
    return fetchData({ method: METHODS.POST, url, body: data });
};

// to update news feed
export const updateNewsFeed = async ({ id, data }) => {
    let url = `${API.NEWS_FEED}/${id}`;
    return fetchData({ method: METHODS.PUT, url, body: data });
};

// to delete news feed
export const deleteNewsFeed = ({ id }) => {
    let url = `${API.NEWS_FEED}/${id}`;
    return fetchData({ method: METHODS.DELETE, url });
};

// to update order of news feed
export const updateNewsFeedOrder = ({ data }) => {
    let url = `${API.NEWS_FEED}${API.ORDER}`;
    return fetchData({ method: METHODS.PUT, url, body: { data } });
};
